import { render, staticRenderFns } from "./DisSetting.vue?vue&type=template&id=4d4de8be&scoped=true&"
import script from "./DisSetting.vue?vue&type=script&lang=js&"
export * from "./DisSetting.vue?vue&type=script&lang=js&"
import style0 from "./DisSetting.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DisSetting.vue?vue&type=style&index=1&id=4d4de8be&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4de8be",
  null
  
)

export default component.exports